import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Button, Dialog } from '@material-ui/core';
import i18n from '../../i18n/i18n';
import { toast } from 'react-toastify';
import AddStorage from './AddStorage';
import { withStyles } from '@material-ui/core/styles';
import { getStorages, deleteStorage, setInitialState, setRowInReducer } from '../../actions/traffic/TrafficActions';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import ViewTransactions from './ViewTransactions';
import { Delete } from '../../utils/Delete';
const CheckboxTable = checkboxHOC(ReactTable);
const styles = theme => ({
});
export class ViewStorage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            showFilters: false,
            selection: [],
            delete: false,
            selectAll: false,
            edit: false,
            viewTransaction: false
        };
    }


    componentDidUpdate(prevProps) {
        const { deleted, storagePostingSuccess, deleteFailed, getStorages, setInitialState } = this.props;
        if (!prevProps.deleted && deleted) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            getStorages(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            setInitialState('storageObj');
            setInitialState('deleted');
        }
        if (!prevProps.storagePostingSuccess && storagePostingSuccess) {
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            getStorages(wrapped.state);
            setInitialState('storagePostingSuccess');
        }
        if (!prevProps.deleteFailed && deleteFailed) {
            toast.error(i18n.t('This item can not be deleted!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                draggablePercent: 80
            });
            setInitialState('deleteFailed');
        }

    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleClick = () => {
        let { edit, add, selection } = this.state;
        let { setInitialState } = this.props;
        if (edit == true && add == false) {
            this.setState({ edit: false })
            setInitialState('storageObj');
        } else if (selection.length > 0 && add == false && edit == false) {
            setInitialState('storageObj');
        }
        this.setState({ add: !add }, () => {
            if (add == true && edit == false) {
                this.setState({
                    selection: [],
                    selectAll: false,
                })
            }
        });
    };

    toggleSelection = (key, shift, row) => {
        const { selection: stateSelection } = this.state;
        const { setInitialState, setRowInReducer, storages } = this.props;
        let selection = [...stateSelection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            setInitialState('storageObj');
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let rowForReducer = storages.filter((storage) => {
                    return storage.id == selection;
                })
                setRowInReducer(rowForReducer[0], 'storageObj');
            }
        });
    };

    toggleAll = () => {
        const { selectAll: selectAllState } = this.state;
        const selectAll = selectAllState ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });


    };

    isSelected = key => {
        const { selection } = this.state;
        return selection.includes(key);
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteStorage(this.state.selection);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }

    onViewTransactionClick = () => {
        this.setState({ viewTransaction: !this.state.viewTransaction })
    }

    render() {
        const columns = [
            {
                Header: i18n.t('ID'),
                accessor: 'id'
            },
            {
                Header: i18n.t('Name'),
                accessor: 'naziv'
            },
            {
                id: 'kapacitet',
                Header: i18n.t('Capacity') + ' (t)',
                accessor: d => parseInt(d.kapacitet)
            },
            {
                Header: i18n.t('Sector'),
                accessor: 'naziv_sektora'
            },
            {
                Header: i18n.t('Group'),
                accessor: 'grupa'
            },
            {
                Header: i18n.t('Ownership'),
                accessor: 'vlasnistvo'
            },
            {
                Header: i18n.t('Description'),
                accessor: 'opis'
            },
        ];
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll, selection, showFilters, add, edit, viewTransaction } = this.state;
        const { theme, storages, storagesPages, storagesFetching, getStorages } = this.props;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#cfc980" : "inherit"
                        }
                    };
                }
                return {};
            },
            getTheadFilterProps: () => {
                return {
                    style: {
                        backgroundColor: theme.palette.primary.main
                    }
                };
            },
            getTheadTrProps: () => {
                return {
                    style: {
                        backgroundColor: theme.palette.secondary.main,
                        color: '#FFFFFF'
                    }
                };
            },
        };
        return (
            <div className="page">
                <div className="table-header">
                    <Button
                        onClick={this.handleClick}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Plus headerIcon" />
                    </Button>
                    <Button
                        onClick={() => this.onSearchClick()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-search headerIcon" />
                    </Button>
                    {selection.length > 0 &&
                        <Button
                            onClick={() => this.onDeleteClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Kanta headerIcon" />
                        </Button>
                    }
                    {selection.length === 1 &&
                        <Button
                            onClick={() => this.onEditClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className="icon-Izmeni1 headerIcon" />
                        </Button>
                    }
                    {selection.length === 1 &&
                        <Button
                            onClick={() => this.onViewTransactionClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className="icon-Informacija headerIcon" />
                        </Button>
                    }

                </div>
                <CheckboxTable data={storages}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={showFilters}
                    pages={storagesPages}
                    loading={storagesFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => getStorages(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                />
                {add && <AddStorage add={add} edit={edit}
                    handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}
                {viewTransaction &&
                    <Dialog
                        open={viewTransaction}
                        maxWidth="lg"
                        fullWidth={true}
                        aria-labelledby="responsive-dialog-title"
                    >
                        <ViewTransactions id_silos={selection[0]} handleClose={this.onViewTransactionClick} />
                    </Dialog>
                }
            </div>

        )
    }


};

function mapStateToProps(state) {
    return {
        storages: state.trafficReducer.storages,
        storageObj: state.trafficReducer.storageObj,
        storagesFetching: state.trafficReducer.storagesFetching,
        storagesPages: state.trafficReducer.storagesPages,
        deleted: state.trafficReducer.deleted,
        deleteFailed: state.trafficReducer.deleteFailed,
        storagePostingSuccess: state.trafficReducer.storagePostingSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getStorages: (state, instance) => dispatch(getStorages(state, instance)),
        deleteStorage: (selection) => dispatch(deleteStorage(selection)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
    }
}

export default withStyles(styles, { withTheme: true })(connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewStorage))